import { IllustrativeIconHandHeartDuocolorAnimated } from '@purpur/library/illustrative-icon/hand-heart-duocolor-animated';

import { IllustrativeContainer, StyledMediaFallback } from './ArticleCard.styles';

export const MediaFallback = () => {
    return (
        <StyledMediaFallback>
            <IllustrativeContainer>
                <IllustrativeIconHandHeartDuocolorAnimated
                    data-test="article-card-fallback-icon"
                    autoplay={false}
                    aria-hidden={true}
                />
            </IllustrativeContainer>
            {/* purpur card.media depends on the presence of an img element */}
            <img alt="" aria-hidden={true} />
        </StyledMediaFallback>
    );
};
